import { useNavigate } from 'react-router-dom';
import { useConfigureLineContext } from '../../../../context/configure-line-context/ConfigureLineContext';
import {
    ButtonPrimary,
    ErrorFeedbackScreen,
    skinVars,
    SuccessFeedbackScreen,
    useWindowSize,
} from '@telefonica/mistica';
import { t } from 'i18next';
import './index.scss';

const BlockedLineFeedback = () => {
    const { blockedLineSuccess, configureLineError, blocked, setConfigureLineError } = useConfigureLineContext();
    const navigate = useNavigate();
    const size = useWindowSize();

    const naigateHome = () => {
        navigate(`/home`);
        setConfigureLineError(null);
    };

    return (
        <div
            className='blocked-line-feedback'
            style={{
                background: blockedLineSuccess
                    ? size.width < 1024 || size.height < 550
                        ? skinVars.colors.backgroundBrand
                        : ''
                    : skinVars.colors.background,
            }}
        >
            {blockedLineSuccess && (
                <SuccessFeedbackScreen
                    title={!blocked ? t('blockLineFeedbackSuccessHeader') : t('unlockLineFeedbackSuccessHeader')}
                    description={
                        !blocked ? t('blockLineFeedbackSuccessDescription') : t('unlockLineFeedbackSuccessDescription')
                    }
                    primaryButton={<ButtonPrimary onPress={naigateHome}>{t('calldivertalerttextbtn')}</ButtonPrimary>}
                />
            )}
            {!blockedLineSuccess && (
                <ErrorFeedbackScreen
                    title={t('supportErrorFeedbackErrorOccurredTitle')}
                    description={t('profileFeedbackErrorSubtitle')}
                    errorReference={
                        configureLineError?.response?.status
                            ? `${t('feedbackCodeError')} ${configureLineError?.response?.status}`
                            : ''
                    }
                    primaryButton={<ButtonPrimary onPress={naigateHome}>{t('calldivertalerttextbtn')}</ButtonPrimary>}
                />
            )}
        </div>
    );
};

export default BlockedLineFeedback;
